export default "__VITE_ASSET__eIKHwy_A__"